
import { Component, Prop, Vue } from 'vue-property-decorator'

const TEMPLATE = require('./NotFound.vtmpl') as string

@Component({
  template: TEMPLATE
})
export default class Home extends Vue {
  private test: number = 20
  private a = 29
}
